import * as React from 'react';
export const AccordionItemContext = React.createContext({
    accordionRef: /* istanbul ignore next */ () => null,
    id: 'id-0',
    onClick: /* istanbul ignore next */ () => null,
    onMouseEnter: /* istanbul ignore next */ () => null,
    onMouseLeave: /* istanbul ignore next */ () => null,
});
